import React, { FC } from 'react'

import { FeedDataType, type FeedData } from 'pages/native/userFeed/types'
import { GameCardItem } from './components/GameCardItem/GameCardItem'
import { LiveStreamCardItem } from './components/LiveStreamCardItem/LiveStreamCardItem'
import { useHistory } from 'react-router-dom'
import { ArticleItem } from './components/ArticleItem/ArticleItem'
import { VideoItem } from './components/VideoItem/VideoItem'

type CardItemProps = {
  item: FeedData
}

let cardBody = <span>else</span>

export const CardItem: FC<CardItemProps> = ({ item }) => {
  const history = useHistory()
  switch (item.type) {
    case FeedDataType.GAME:
      cardBody = <GameCardItem item={item} />
      break
    case FeedDataType.LIVESTREAM:
      cardBody = <LiveStreamCardItem item={item} />
      break
    case FeedDataType.ARTICLE:
      cardBody = <ArticleItem item={item} />
      break
    case FeedDataType.VIDEO:
      cardBody = <VideoItem item={item} />
      break
    default:
      cardBody = <span>---</span>
  }
  return <div onClick={() => history.push(item.targetUrl)}>{cardBody}</div>
}
